import "../css/gallery.css";
import { useState, useRef, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

function Gallery({ gallery = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollRef = useRef(null);
  const autoplaySpeed = 4000; // Tiempo en milisegundos (4 segundos)

  // Función principal para mover el scroll
  const scrollToImage = (index) => {
    const container = scrollRef.current;
    if (container) {
      container.scrollTo({
        left: index * container.offsetWidth,
        behavior: "smooth",
      });
      setCurrentIndex(index);
    }
  };

  // Lógica de Autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      // Si estamos en la última imagen, vuelve a la primera (0), si no, a la siguiente
      const nextIndex = currentIndex === gallery.length - 1 ? 0 : currentIndex + 1;
      scrollToImage(nextIndex);
    }, autoplaySpeed);

    // Limpieza: muy importante para que no se dupliquen los intervalos
    return () => clearInterval(interval);
  }, [currentIndex, gallery.length]); // Se reinicia el timer si el índice cambia

  const handleNavigation = (direction) => {
    const newIndex = direction === "right" 
      ? (currentIndex + 1) % gallery.length  // Bucle infinito hacia adelante
      : (currentIndex - 1 + gallery.length) % gallery.length; // Bucle infinito hacia atrás
    scrollToImage(newIndex);
  };

  if (!gallery.length) return null;

  return (
    <div className="gallery-container">
      <div className="gallery-scroll-container" ref={scrollRef}>
        {gallery.map((item, index) => (
          <div className="item-gallery" key={item.id || index}>
            <img src={item.url} alt={item.title || `Slide ${index}`} />
          </div>
        ))}
      </div>

      {/* Flechas de navegación */}
      <button className="nav-btn left" onClick={() => handleNavigation("left")}>
       <ChevronLeft></ChevronLeft>
      </button>

      <button className="nav-btn right" onClick={() => handleNavigation("right")}>
       <ChevronRight/>
      </button>

      {/* Indicadores */}
      <div className="gallery-indicators">
        {gallery.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => scrollToImage(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default Gallery;